import Image from "next/image"
import LogoLight from "@/assets/logo.svg"
import LogoDark from "@/assets/logo_dark.svg"
import IconLight from "@/assets/logo_icon.svg"
import IconDark from "@/assets/logo_icon_dark.svg"

interface LogoProps {
  // The wordmark, or the round mark alone.
  variant?: 'full' | 'icon'
  // Sizes the image: give a height and `w-auto` for the wordmark, a `size-*` for the icon.
  className?: string
}

// The WeSend logo in the ink that suits the theme. Both inks are rendered and CSS shows one, so
// the right one is there on first paint. To show or hide the logo itself, wrap it.
export default function Logo({ variant = 'full', className }: LogoProps) {
  const light = variant === 'icon' ? IconLight : LogoLight
  const dark = variant === 'icon' ? IconDark : LogoDark
  const size = className || (variant === 'icon' ? 'size-8' : 'h-7 w-auto')

  return (
    <>
      <Image src={light} alt="WeSend" priority className={`${size} dark:hidden`} />
      <Image src={dark} alt="WeSend" priority className={`${size} hidden dark:block`} />
    </>
  )
}
